import styled from '@emotion/styled'

export const StyleHamBurgerMenu = styled.div`
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
  height: 30px;
`

export const StyleMenuWrapper = styled.div<{ isMenuOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: ${(props: any) => (props.isMenuOpen ? '100%' : '0px')};
  height: 100vh;
  opacity: ${(props: any) => (props.isMenuOpen ? 1 : 0)};
  background-color: white;
  top: 0;
  left: 0;
  transition: all 100ms linear;
  padding: 25px 30px;
  overflow-y: auto;
  @media (min-width: 770px) {
    display: none;
  }
`

export const StyleHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 30px;
`

export const StyleLinkWrapper = styled.nav`
  display: flex;
  flex-direction: column;

  width: 100%;
`

export const StyleLink = styled.a`
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
  text-decoration: none;
  transition: all 0.2s ease;
  border-radius: 5px;
  padding: 20px 10px;
  cursor: pointer;
  &:hover {
    background-color: #164779;
    color: white;
  }
  &.active {
    background-color: #164779; /* 👈 Active color */
    color: white;
  }
`

export const StyleButtonWrapper = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 20px;
`

export const StyleButtonOutline = styled.button`
  width: 100%;
  padding: 8px;
  border: 2px solid #262f77;
  background-color: transparent;
  color: #262f77;
  font-size: 12px;

  border-radius: 6px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
`

export const StyleButtonSolid = styled.button`
  width: 100%;
  padding: 8px;
  border: none;
  background-color: #262f77;
  color: white;
  font-size: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
`
